import { Flex, Image, Show, Skeleton, Text, useToken } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import CenteredCardLayout from '@/components/Organisms/CenteredCardLayout';
import { permissionToUrl } from '@/constants';
import usePermission from '@/hooks/usePermission';

const mindsightLogo = '/svgs/mindsightLogo.svg';
const taDmeLogo = '/svgs/taDmeLogo.svg';
const taLogo = '/svgs/taLogo.svg';

const ChoosePlatformCard = ({ children }: { children: React.ReactNode }) => {
	const [brand600] = useToken('colors', ['brand.600']);
	const navigate = useNavigate();

	const { hasPermission } = usePermission();

	const firstMatchedRouteAsPerPermission = Object.entries(permissionToUrl).find(([permission]) => {
		return hasPermission([permission]);
	});

	return (
		<Flex
			onClick={() => {
				navigate(firstMatchedRouteAsPerPermission?.at(1) || '/benefits-verifications', { replace: true });
			}}
			w={'300px'}
			h={'90px'}
			rounded="xl"
			border="1px solid"
			borderColor="brand.robotGrey"
			bg="brand.white"
			cursor="pointer"
			justifyContent="center"
			alignItems="center"
			transition="all 0.3s ease"
			_hover={{
				boxShadow: `0 0 15px 5px ${brand600}`,
				border: 'none',
			}}
		>
			{children}
		</Flex>
	);
};

const ChoosePlatform = () => {
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsLoading(false);
		}, 1000);

		return () => clearTimeout(timer);
	}, []);

	return (
		<CenteredCardLayout>
			<Flex
				flexDirection="column"
				gap={8}
				mt={{ base: 6, md: 5 }}
				mb={{ base: 6, md: 0 }}
			>
				<Flex flexDirection="column" gap={4}>
					<Text
						fontSize="lg"
						color="brand.textDark"
						fontWeight="normal"
						textAlign="center"
					>
						Please select an app from the menu
					</Text>
					<Flex gap={4} justifyContent="center">
						<Show
							when={isLoading}
							fallback={
								<>
									<ChoosePlatformCard>
										<Image
											objectFit="contain"
											src={mindsightLogo}
											alt="Mindsight Logo"
											width={150}
											height={50}
										/>
									</ChoosePlatformCard>
									<ChoosePlatformCard>
										<Image
											objectFit="contain"
											src={taLogo}
											alt="TA DME Logo"
											width={50}
											height={50}
											mr={2}
										/>
										<Image
											objectFit="contain"
											src={taDmeLogo}
											alt="TA DME Logo"
											width={100}
											height={50}
										/>
									</ChoosePlatformCard>
								</>
							}
						>
							<Skeleton
								w={'200px'}
								h={'90px'}
								rounded="xl"
								_dark={{ bg: 'gray.700' }}
								_light={{ bg: 'gray.200' }}
							/>
							<Skeleton
								w={'200px'}
								h={'90px'}
								rounded="xl"
								_dark={{ bg: 'gray.700' }}
								_light={{ bg: 'gray.200' }}
							/>
						</Show>
					</Flex>
				</Flex>
			</Flex>
		</CenteredCardLayout>
	);
};

export default ChoosePlatform;
